import React from "react";
import { Route, Routes } from "react-router";
import { useTheme } from "styled-components";
import { NavBar } from "./components";
import {
  PortfolioAnalysis,
  PortfolioComposer,
  PortfolioEditorPage,
  PortfolioShared,
} from "./pages";

const App: React.FC = () => {
  const theme = useTheme();

  return (
    <>
      {theme.navbar.show && <NavBar />}
      <Routes>
        <Route path="/" element={<PortfolioComposer />} />
        <Route path="editor" element={<PortfolioEditorPage />} />
        <Route path="analysis" element={<PortfolioAnalysis />} />
        <Route path="shared" element={<PortfolioShared />} />
      </Routes>
    </>
  );
};

export default App;
